import React from "react";

const BreadCrumbContainer = ({ children }) => {
  return <div className="flex gap-x-2 flex-wrap">{children}</div>;
};

export default BreadCrumbContainer;
